module.exports = __webpack_public_path__ + "img/infraicon2.8d2aee88.svg";